module.exports = __webpack_public_path__ + "img/userFlow1_old.03c1c727.png";